import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FulfillmentChannel } from '@/Enums/FulfillmentChannel';
import { useLocalization, useSelectedOrdersRows } from '@/Hooks';
import { localizationUtils } from '@/Utils/localizationUtils';
import { globalSelectors } from '@/Redux/Global/selectors';

export const useOrderFulfillment = () => {
  const {
    menu: { Tooltips, ShippingLabel },
  } = useLocalization();

  const { orderRows } = useSelectedOrdersRows();
  const localization = useSelector(globalSelectors.localization);

  const ordersFulfilledByMarketplace = orderRows
    .filter((o) => o.fulfillmentChannel === FulfillmentChannel.Marketplace)
    .map((o) => o.userOrderId);

  const changeOrderStatusProps = useMemo(() => {
    const hasFulfilledOrders = ordersFulfilledByMarketplace.length > 0;
    const params = [ordersFulfilledByMarketplace.join(', '), ordersFulfilledByMarketplace.length];

    const message = localizationUtils.insertTranslatedParamsToString(
      Tooltips.ChangeOrderStatusDisabledFulfilledByMarketplace.Message,
      params,
      Tooltips.parts,
      localization,
    );

    return {
      isDocumentIconDisabled: hasFulfilledOrders,
      disabledDocumentMessage: hasFulfilledOrders ? message : '',
    };
  }, [localization, ordersFulfilledByMarketplace]);

  const feedbackProps = useMemo(() => {
    const hasFulfilledOrders = ordersFulfilledByMarketplace.length > 0;
    const params = [ordersFulfilledByMarketplace.join(', '), ordersFulfilledByMarketplace.length];

    const message = localizationUtils.insertTranslatedParamsToString(
      Tooltips.CreateFeedbackDisabledFulfilledByMarketplace.Message,
      params,
      Tooltips.parts,
      localization,
    );

    return {
      isDocumentIconDisabled: hasFulfilledOrders,
      disabledDocumentMessage: hasFulfilledOrders ? message : '',
    };
  }, [localization, ordersFulfilledByMarketplace]);

  const shippingLabelProps = useMemo(() => {
    const deliveryNotRequired = orderRows.some((item) => !item.isDeliveryRequired);

    if (deliveryNotRequired) {
      return {
        isDocumentIconDisabled: true,
        disabledDocumentMessage: Tooltips.DeliveryNotRequired.Message,
      };
    }

    const addressNotExists = orderRows.some((item) => !item.originalShippingCityName);

    if (addressNotExists) {
      return {
        isDocumentIconDisabled: true,
        disabledDocumentMessage: ShippingLabel.AddressNotExistsMessage,
      };
    }

    const hasFulfilledOrders = ordersFulfilledByMarketplace.length > 0;
    const params = [ordersFulfilledByMarketplace.join(', '), ordersFulfilledByMarketplace.length];

    const message = localizationUtils.insertTranslatedParamsToString(
      Tooltips.CreateShippingLabelDisabledFulfilledByMarketplace.Message,
      params,
      Tooltips.parts,
      localization,
    );

    return {
      isDocumentIconDisabled: hasFulfilledOrders,
      disabledDocumentMessage: hasFulfilledOrders ? message : '',
    };
  }, [localization, ordersFulfilledByMarketplace, orderRows]);

  return {
    feedbackProps,
    shippingLabelProps,
    changeOrderStatusProps,
  };
};
